import Vue from 'vue';
import { charcounter } from './charcounter';

Vue.directive('charcounter', charcounter);
